import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { ProductImage } from './ProductImage';
export function Hero() {
  return <section className="pt-5 pb-5 px-4 sm:px-6 bg-white text-center" data-id="element-75" data-mp="ei1w7odj86z0">
      <div className="inline-block px-3 py-1 rounded-full bg-gold/15 border border-gold/40 text-navy font-heading font-bold text-[10px] sm:text-xs uppercase tracking-widest mb-2.5" data-id="element-76" data-mp="9lbgj25n3de4">
        Système Complet 6-en-1
      </div>

      <h1 className="text-3xl sm:text-5xl font-display text-navy leading-[1.05] mb-2" data-id="element-77" data-mp="1274nzp1vrg78">
        Le Système Complet de Planification pour les Professionnels du Fitness
        Senior
      </h1>

      <p className="text-[13px] sm:text-base text-ink font-semibold leading-snug mb-3 max-w-2xl mx-auto" data-id="element-78" data-mp="sde12olejdtn">
        Gagnez des heures de préparation chaque semaine grâce à un système
        professionnel conçu pour construire vos séances, organiser vos
        programmes, suivre la progression de vos participants et planifier vos
        cours avec plus d'efficacité — sans repartir de zéro avant chaque
        séance.
      </p>

      <div className="mb-3" data-id="element-79" data-mp="3o7c0jz1umrh5">
        <ProductImage className="max-w-[260px] sm:max-w-sm" data-id="element-80" data-mp="3o6kdjcmbi22h" />
      </div>

      <div className="mb-2.5 max-w-lg mx-auto" data-id="element-81" data-mp="39aupza1hhgvn">
        <CTAButton data-id="element-82" data-mp="39a36gxl5v9lq">🚀 OUI ! JE VEUX MON SYSTÈME MAINTENANT</CTAButton>
      </div>

      <TrustRow data-id="element-83" data-mp="3e84m18jdoqsg" />
    </section>;
}